// extracted by mini-css-extract-plugin
export default {"paymentOptions":"Z9EPA","title":"YnVk1","titleThin":"rkJHN","description":"BBVgH","marquee":"_0Im-1","paymentOption":"KAxK7","downloadButton":"jck90","skeleton-progress":"Pkqfo"};